import { combineReducers } from 'redux';
import branchMapReducer from './branchMapReducer';
import mapReducer from './mapReducer';
import appReducer from './AppReducer';

const rootReducer = combineReducers({
  mapStore: mapReducer,
  branchMapStore: branchMapReducer,
  appStore: appReducer,
});

export default rootReducer;

export type RootState = ReturnType<typeof rootReducer>;
